var React = require('react');

function Usage (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M42.67 42.32L29.84 50.1V20.61l12.83-7.79v29.5z","key":0}),React.createElement("path",{"fill":"#eeeef4","d":"M20.78.18L7.95 7.96l21.89 12.65 12.83-7.79L20.78.18z","key":1}),React.createElement("path",{"fill":"#dce0f1","d":"M7.95 37.46L29.84 50.1V20.61L7.95 7.96v29.5z","key":2}),React.createElement("path",{"fill":"#3e3c5c","d":"M35.39 30.47l-3.45 1.99V23.1l3.45-2v9.37z","key":3}),React.createElement("path",{"fill":"#9bbae7","d":"M10.04 33.8l4.93 2.85V18.03l-4.93-2.85V33.8z","key":4})]);
}

Usage.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 50 50"};

module.exports = Usage;

Usage.default = Usage;
